import React from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import {Divider, IconButton, Typography} from '@material-ui/core';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: '15px',
  },
  root1: {
    margin: 0,
    padding: '20px',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: 4,
    color: theme.palette.grey[500],
  },
});
const DialogWithTitle = withStyles(styles)((props) => {
  const {children, classes, onClose, ...other} = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h4">{children}</Typography>
      <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </MuiDialogTitle>
  );
});
const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(3),
    justifyContent: 'center',
  },
}))(MuiDialogActions);
const useStyles = makeStyles((theme) => ({
  expiryDialogContent: {
    fontSize: '1rem',
  },
}));
const LockAlert = ({open, handleForward, handleClose, accNo, lockAlertCondition}) => {
  const classes = useStyles();
  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      onClose={handleClose}
      open={open}
      fullWidth
      maxWidth={'sm'}
    >
      <DialogWithTitle id="customized-dialog-title" onClose={handleClose}>
        <ReportProblemOutlinedIcon /> Alert
      </DialogWithTitle>
      <Divider />
      <DialogContent className={`text-center font-weight-bold ${classes.expiryDialogContent}`}>
        {lockAlertCondition ?
          `Account ${accNo} has been locked, please try again after some time or go to next account` :
          `Account ${accNo} is not present in the Work Queue any further`}
      </DialogContent>
      <DialogActions>
        <div className={`button-spacing-mb new-standard-textfields`}>
          <Button
            onClick={handleClose}
            variant="outlined"
            className={`reset-btn mr-1 ${classes.buttonRoot}`}
          >
            Close
          </Button>
          <Button
            onClick={handleForward}
            variant="outlined"
            className={`search-btn ml-1 ${classes.buttonRoot}`}
          >
            Next account
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default LockAlert;
